/**
 * @file Agent 聊天记录
 * @author malcolmmzma
 */

import React, { useRef } from 'react';
import AdqIcon from '@tencent/adq-icons';
import { Loading } from '@tencent/spaui';
import AgentContainer from '../components/container';
import { useHistory } from 'react-router-dom';
import { Flex, Titlebar, Text, Divider, Frame } from '@tencent/odc';
import { useInfiniteScroll } from 'ahooks';
import { getSessionList } from '../../../api/analysis';
import { useSearchParams } from '../hooks/useSearchParams';

import '../index.less';

const PAGE_SIZE = 50;

export default () => {
  const ref = useRef<HTMLDivElement>(null);

  const history = useHistory();

  const { searchParamStr } = useSearchParams();

  const { data, loading, loadingMore, noMore } = useInfiniteScroll(
    (d: any) => {
      const page = d ? d?.page_info?.page + 1 : 1;
      return getSessionList({ page, page_size: PAGE_SIZE });
    },
    {
      target: ref,
      isNoMore: (d) => {
        if (!d) {
          return false;
        }
        const { page_info: pageInfo } = d;
        return pageInfo.total_page === 0 || pageInfo.page === pageInfo.total_page;
      },
    },
  );

  return (
    <AgentContainer>
      <Frame className="tw-h-full tw-w-full tw-px-[120px] tw-py-[80px] tw-rounded-[20px]" bg="white">
        <Flex className="tw-h-full tw-max-w-7xl tw-w-full tw-m-auto" column gap={24}>
          <Flex justifyContent="between" alignItems="center">
            <Titlebar title="历史记录" size={2} />
            <Text size="small" type="comment">
              仅保留近 1 个月的生成任务
            </Text>
          </Flex>
          {!loading ? (
            <Flex ref={ref} column gap={12} className="tw-overflow-auto">
              {data?.list?.map((item: any) => (
                <Flex
                  key={item.session_id}
                  column
                  radius={12}
                  onClick={() => history.push(`/analysis/ai-agent/${item.session_id}?${searchParamStr}`)}
                  className="tw-group tw-relative tw-px-6 tw-py-[19px] cursor-pointer tw-bg-black-01 hover:tw-bg-black-02 tw-transition-all"
                >
                  <Text type="primary" size="large" className="tw-font-semibold">
                    {item.title}
                  </Text>
                  <Text type="comment">
                    任务ID：{item.session_id || '-'}
                    <Divider type="vertical" />
                    {item.created_at || '-'}
                  </Text>
                  <AdqIcon
                    name="right"
                    className="tw-absolute tw-right-6 tw-top-1/2 tw-transform tw--translate-y-1/2 tw-hidden group-hover:tw-block"
                    width={16}
                    height={16}
                  />
                </Flex>
              ))}
              {!noMore && loadingMore && <Loading />}
              {noMore && (
                <Text type="comment" style={{ textAlign: 'center' }}>
                  没有更多历史记录
                </Text>
              )}
            </Flex>
          ) : (
            <Loading />
          )}
        </Flex>
      </Frame>
    </AgentContainer>
  );
};
